import { RouteRecordRaw } from 'vue-router';

const adminRoutes: RouteRecordRaw[] = [
   {
      name: 'admin',
      path: '/admin',
      meta: {
         permission: 'tenants',
         scopes: ['admin'],
      },
      component: () => import('@/modules/admin/pages/Index.vue'),
      redirect: { name: 'admin-tenants' },
      children: [
         {
            name: 'admin-tenants',
            path: 'tenants',
            meta: {
               permission: 'tenants',
               scopes: ['admin'],
            },
            component: () => import('@/modules/admin/pages/Tenants.vue'),
         },
         {
            name: 'admin-customers',
            path: 'customers',
            meta: {
               permission: 'supers',
               scopes: ['admin'],
            },
            component: () => import('@/modules/admin/pages/Customers.vue'),
         },
      ],
   },
];

export default adminRoutes;
